import { useQuery } from '@tanstack/react-query';
import { systemApi } from '@/lib/api/system';
import type { SiteConfig } from '@comp-sys/shared';

const DEFAULT_SITE_CONFIG: SiteConfig = {
  systemName: '',
  contactEmail: null,
  contactPhone: null,
  logoUrl: null,
  showLogo: true,
  showText: true,
  crop: null,
};

export function useSiteConfig() {
  const { data, isLoading } = useQuery<SiteConfig>({
    queryKey: ['system', 'site-config'],
    queryFn: systemApi.getSiteConfig,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  const config = data ?? DEFAULT_SITE_CONFIG;

  return {
    siteConfig: config,
    systemName: config.systemName,
    isLoading,
  };
}
